/**
 * @file MostVisitedPagesReportParameters.js
 * @description Most Visited Pages report parameter controls used by GenerateReportPage.
 */

import { SearchableDropdown } from '../helpers/SearchableDropdown';
import { getText } from '../../i18n';

function getSavedOptions(options, selectedIds) {
    const selectedIdSet = new Set((selectedIds || []).map(String));
    return (options || []).filter(option =>
        selectedIdSet.has(String(option.id)),
    );
}

function MostVisitedPagesReportParameters({
    isReadOnlyMode,
    populationGroupOptions,
    selectedPopulationGroups,
    handlePopulationGroupsChange,
}) {
    return (
        <div
            style={{
                width: '100%',
                margin: '0 auto',
                display: 'grid',
                gap: '40px',
            }}
        >
            <div>
                <div
                    className="file-form-label"
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_c869672b9f14')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_ac7533a67d32')}
                    options={populationGroupOptions}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handlePopulationGroupsChange(selectedOptions)
                    }
                    savedOptions={getSavedOptions(
                        populationGroupOptions,
                        selectedPopulationGroups,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
        </div>
    );
}

export default MostVisitedPagesReportParameters;
